import * as firebase from 'firebase/app'
import 'firebase/auth';
import 'firebase/database';
// import AppConfig from 'src/config/AppConfig';

// import config from 'config';

const FIREBASE_CONFIG:object = {
  stagingConfig: {
    apiKey: "AIzaSyBAAMLgq8tHThC4XbUR2156v6LsXyS_qYE",
    authDomain: "slg-staging.firebaseapp.com",
    databaseURL: "https://slg-staging.firebaseio.com",
    projectId: "slg-staging",
    storageBucket: "slg-brexit-city.appspot.com",
  },
  treasureHunterConfig: {
    apiKey: "AIzaSyDTpJyO-OfDHBSy7ruvbgMjmDq5mn_7kgo",
    authDomain: "seriouslearninggames.firebaseapp.com",
    databaseURL: "https://seriouslearninggames.firebaseio.com",
    projectId: "seriouslearninggames",
    storageBucket: "seriouslearninggames.appspot.com",
  },
  brexitCityConfig: {
    apiKey: "AIzaSyAIrggQk0FmM7E5ZWuzyJRuzfpfTNkbTeo",
    authDomain: "slg-brexit-city.firebaseapp.com",
    databaseURL: "https://slg-brexit-city.firebaseio.com",
    projectId: "slg-brexit-city",
    storageBucket: "slg-brexit-city.appspot.com",
  },
  cyberSecurityConfig: {
    apiKey: "AIzaSyAOxiaaWShva7E5BZPTPaOf4sF6yc-vDhE",
    authDomain: "slg-cyber-security.firebaseapp.com",
    databaseURL: "https://slg-cyber-security.firebaseio.com",
    projectId: "slg-cyber-security",
    storageBucket: "slg-cyber-security.appspot.com",
  },
  pretorianConfig: {
    apiKey: "AIzaSyBGqDjdhSP6HNS47cFTiquGQPFl3565dsw",
    authDomain: "praetorian-security.firebaseapp.com",
    databaseURL: "https://praetorian-security.firebaseio.com",
    projectId: "praetorian-security",
    storageBucket: "praetorian-security.appspot.com",
  },
}

// export REACT_APP_FIREBASE_CONFIG=treasureHunterConfig
// console.log("Env:", process.env)

let config;
if (process.env.REACT_APP_FIREBASE_CONFIG == null || FIREBASE_CONFIG[process.env.REACT_APP_FIREBASE_CONFIG] == null) {
  console.log("[firebase.tsx] Unknown config");
  // console.log('[firebase.tsx] No REACT_APP_FIREBASE_CONFIG specified. Try using `REACT_APP_FIREBASE_CONFIG="treasureHunterConfig" npm start`')
} else {
  // console.log("[firebase.tsx]", FIREBASE_CONFIG[process.env.REACT_APP_FIREBASE_CONFIG]);
  config = FIREBASE_CONFIG[process.env.REACT_APP_FIREBASE_CONFIG];
}


// console.log("Config Settings:", AppConfig.CONFIGS[process.env.REACT_APP_CONFIG])
// console.log("Selected config:", AppConfig.config)
// console.log("Proj:", process.argv)
// console.log("Test:",process.env.npm_package_config_foo)

// let config;
// switch (process.env.REACT_APP_ID) {
//   case "treasureHunter":
//     config = treasureHunterConfig;
//     break;
//   case "brexitCity":
//     config = brexitCityConfig;
//     break;
//   default:
//     console.log('[firebase.tsx] No REACT_APP_ID specified. Try using `REACT_APP_ID="treasureHunter" npm start`')
//     break;
// }

// const config = process.env.NODE_ENV === 'production'
//   ? prodConfig
//   : devConfig;

if (!firebase.apps.length) {
  firebase.initializeApp(config);
  console.log("firebase initialised")
}

const db = firebase.database();
const auth = firebase.auth();

export {
  db,
  auth,
};



// WEBPACK FOOTER //
// ./src/firebase/firebase.tsx